/* eslint-disable no-console */
import config from '../config';

const isDevelopment = config.NODE_ENV === 'development';

export const logger = {
  debug: (message: string, ...args: unknown[]): void => {
    // Using console.log instead of console.debug because many browsers filter out debug messages by default
    console.log(`🐛 [DEBUG] ${message}`, ...args);
  },
  info: (message: string, ...args: unknown[]): void => {
    if (isDevelopment) {
      console.info(`ℹ️ [INFO] ${message}`, ...args);
    }
  },
  warn: (message: string, ...args: unknown[]): void => {
    console.warn(`⚠️ [WARN] ${message}`, ...args);
  },
  error: (message: string, ...args: unknown[]): void => {
    console.error(`❌ [ERROR] ${message}`, ...args);
  },
};
